// @flow
import React, { Component } from 'react';
import UserContent from 'components/user/UserContent';
import UserTagView from 'components/user/UserTagView';
import UserProductsTagView from 'components/user/UserProductsTagView';
import { type ContextRouter, type Match, Route, withRouter } from 'react-router-dom';
import { ProfileActions } from 'store/actionCreators';
import { type ProductsTagCountInfo, type Profile, type TagCountInfo } from 'store/modules/profile';
import { connect } from 'react-redux';
import type { State } from 'store';
import { compose } from 'redux';
import UserPostsSubpage from 'pages/user/UserPostsSubpage';
import UserProductsSubpage from 'pages/user/UserProductsSubpage';
import UserHistorySubpage from 'pages/user/UserHistorySubpage';
import UserAboutSubpage from 'pages/user/UserAboutSubpage';
import UserSeriesSubpage from 'pages/user/UserSeriesSubpage';

type Props = {
  match: Match,
  tagCounts: ?(TagCountInfo[]),
  productsTagCounts: ?(ProductsTagCountInfo[]),
  shouldCancel: boolean,
  profile: ?Profile,
  side: boolean,
} & ContextRouter;

class UserContentContainer extends Component<Props> {
  initialize = async () => {
    const { shouldCancel, history } = this.props;
    if (shouldCancel) return;
    const { username } = this.props.match.params;
    if (!username) return;
    if (username === (this.props.profile && this.props.profile.username)) return;
    ProfileActions.initialize();
    try {
      await ProfileActions.getProfile(username);
      await ProfileActions.getUserTags(username);
      await ProfileActions.getUserProductsTags(username);
    } catch (e) {
      console.log(e);
      if (e && e.response && e.response.status === 404) {
        this.props.history.replace('/404');
      }
    }
  };

  componentDidMount() {
    this.initialize();
  }

  onSelectTag = (tagName: string) => {
    ProfileActions.setRawTagName(tagName);
  };

  componentDidUpdate(prevProps) {
    if (this.props.match.params.username !== prevProps.match.params.username) {
      this.initialize();
    }
  }

  render() {
    const { match, tagCounts, productsTagCounts, side, location } = this.props;
    const username = match.params.username || '';
    const type = match.params.tab || 'posts';
    return (
      <Route path="/@:username/like" component={UserHistorySubpage} />
      // <UserContent
      //   type={type}
      //   username={username}
      //   side={
      //     side &&
      //     (type === 'posts' ? (
      //       <UserTagView tagCounts={tagCounts} username={username} onSelectTag={this.onSelectTag} />
      //     ) : (
      //       <UserProductsTagView
      //         tagCounts={productsTagCounts}
      //         username={username}
      //         onSelectTag={this.onSelectTag}
      //       />
      //     ))
      //   }
      // >
      //   <Route exact path="/@:username" component={UserPostsSubpage} />
      //   <Route exact path="/@:username/products" component={UserProductsSubpage} />
      //   <Route path="/@:username/series" component={UserSeriesSubpage} />
      //   <Route path="/@:username/history" component={UserHistorySubpage} />
      //   <Route path="/@:username/tags/:tag" component={UserPostsSubpage} />
      //   <Route path="/@:username/products/tags/:tag" component={UserProductsSubpage} />
      //   <Route path="/@:username/about" component={UserAboutSubpage} />
      // </UserContent>
    );
  }
}

export default compose(
  withRouter,
  connect(
    ({ profile, common }: State) => ({
      profile: profile.profile,
      tagCounts: profile.tagCounts,
      productsTagCounts: profile.productsTagCounts,
      shouldCancel: common.ssr && !common.router.altered,
      side: profile.side,
    }),
    () => ({}),
  ),
)(UserContentContainer);



// WEBPACK FOOTER //
// ./src/containers/user/UserContentContainer.js